import { IActivityTypes } from '@/types/activity-log.types';
import { ProjectStateReducerCreator, TSaveWorkingProjectByFieldsPayload } from '../types';

const saveWorkingProjectByFieldsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: TSaveWorkingProjectByFieldsPayload) => {
    if (!state.workingProject) return;

    state.savingWorkingProject = true;

    const {
      saveId,
      sessionsToSave,
      refetchProjectAfterSave,
      bypassProjectSave,
      errorMessageOverride,
      ...updatedProjectFields
    } = action.payload;

    state.saveId = saveId ?? state.saveId;
    state.refetchProjectAfterSave = !!refetchProjectAfterSave;
    state.savingErrorMessageOverride = errorMessageOverride;

    // update project keys
    if (!bypassProjectSave) {
      Object.entries(updatedProjectFields).forEach((data) => {
        const key = data[0];
        const value = data[1];
        if (state.workingProject && key in state.workingProject) {
          // @ts-expect-error using dynamic key makes typescript think this is "any" and type casting doesn't fix it
          state.workingProject[key] = value;
        }
      });
    }

    // update sessions AFTER project so we get both update fields just in case someone passes in updates to a session
    // in both places - not sure why they'd do that, but just in case.
    // by adding sessionsToUpdateAfterProjectSave, save-project-middleware will update the session after the project is saved
    if (state.workingProject?.sessions && sessionsToSave) {
      const sessionsToSaveMap = new Map(sessionsToSave.map((s) => [s.uuid, s.uuid]));
      const allSessions = state.workingProject.sessions.map((s) => {
        const foundSession = sessionsToSave.find((sts) => sts.uuid === s.uuid);
        if (!foundSession) return s;
        return {
          ...s,
          ...foundSession,
        };
      });
      // update sessions in redux first
      state.workingProject.sessions = allSessions;
      // then extract only the sessions that actually require updating and pass them into the save mechanism
      const onlyUpdatedSessions = allSessions.filter((s) => sessionsToSaveMap.has(s.uuid));
      state.sessionsToUpdateAfterProjectSave = onlyUpdatedSessions || null;

      // update working session if its one of the updated sessions
      if (state.workingSession) {
        const updatedWorkingSession = allSessions.find((s) => s.uuid === state.workingSession?.uuid);
        if (updatedWorkingSession) {
          state.workingSession = updatedWorkingSession;
        }
      }

      // Update activity tracking
      state.mostRecentActivityLogUpdate = new Date().toISOString();
      state.mostRecentActivityLogType = IActivityTypes.events;
    }
  });
};

export default saveWorkingProjectByFieldsReducer;
